module.exports = __webpack_public_path__ + "media/MRI7-ad.b15105b8.mp3";